 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXT9780061970009_COVER from '@/components/text/9780061970009_Cover'
 import LOVE_1 from '@/components/love_1'
 import TEXT9780061970009_TITLEPAGE from '@/components/text/9780061970009_Titlepage'
 import TEXT9780061970009_DEDICATION from '@/components/text/9780061970009_Dedication'
 import TEXT9780061970009_EPIGRAPH from '@/components/text/9780061970009_Epigraph'
 import TEXTNAV from '@/components/text/nav'
 import TEXT9780061970009_FRONTMATTER from '@/components/text/9780061970009_Frontmatter'
 import TEXT9780061970009_PROLOGUE from '@/components/text/9780061970009_Prologue'
 import TEXT9780061970009_PART_1 from '@/components/text/9780061970009_Part_1'
 import TEXT9780061970009_PART_2 from '@/components/text/9780061970009_Part_2'
 import TEXT9780061970009_PART_3 from '@/components/text/9780061970009_Part_3'
 import TEXT9780061970009_PART_4 from '@/components/text/9780061970009_Part_4'
 import TEXT9780061970009_EPILOGUE from '@/components/text/9780061970009_Epilogue'
 import LOVE_2 from '@/components/love_2'
 import TEXT9780061970009_NOTE from '@/components/text/9780061970009_Note'
 import TEXT9780061970009_BACKMATTER from '@/components/text/9780061970009_Backmatter'
 import TEXT9780061970009_MAP from '@/components/text/9780061970009_Map'
 import TEXT9780061970009_PS from '@/components/text/9780061970009_PS'
 import TEXT9780061970009_PS_ABOUT_THE_AUTHOR from '@/components/text/9780061970009_PS_About_the_Author'
 import TEXT9780061970009_PS_ABOUT_BOOK from '@/components/text/9780061970009_PS_About_Book'
 import TEXT9780061970009_PS_READ_ON from '@/components/text/9780061970009_PS_Read_On'
 import TEXT9780061970009_ALSO_BY from '@/components/text/9780061970009_Also_by'
 import TEXT9780061970009_COPYRIGHT from '@/components/text/9780061970009_Copyright'
 import TEXTABOUT_THE_PUBLISHER from '@/components/text/About_the_Publisher'
 import TEXT9780061970009_FOOTNOTE from '@/components/text/9780061970009_Footnote'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/text/nav",
 			"name" : "text/nav",
 			"component" : TEXTNAV
 		},
 		{
 			"path" : "/text/9780061970009_Frontmatter",
 			"name" : "text/9780061970009_Frontmatter",
 			"component" : TEXT9780061970009_FRONTMATTER
 		},
 		{
 			"path" : "/text/9780061970009_Prologue",
 			"name" : "text/9780061970009_Prologue",
 			"component" : TEXT9780061970009_PROLOGUE
 		},
 		{
 			"path" : "/text/9780061970009_Part_1",
 			"name" : "text/9780061970009_Part_1",
 			"component" : TEXT9780061970009_PART_1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js